export default __webpack_public_path__ + "static/media/target-default-image.3dd55a53.svg";